import _toConsumableArray from "C:\\Users\\rose\\Documents\\learning\\card-memory-game\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "C:\\Users\\rose\\Documents\\learning\\card-memory-game\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\rose\\Documents\\learning\\card-memory-game\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { Proxifier } from './Proxyfier';
export var MutationTree =
/*#__PURE__*/
function () {
  function MutationTree(master, proxifier) {
    _classCallCheck(this, MutationTree);

    this.mutationCallbacks = [];
    this.mutations = [];
    this.objectChanges = new Set();
    this.isTracking = false;
    this.isTracking = true;
    this.master = master;
    this.proxifier = proxifier || new Proxifier(this);
    this.state = this.proxifier.proxify(master.sourceState, '');
  }

  _createClass(MutationTree, [{
    key: "getMutations",
    value: function getMutations() {
      var mutations = this.mutations.slice();
      this.mutations.length = 0;
      return mutations;
    }
  }, {
    key: "getObjectChanges",
    value: function getObjectChanges() {
      var objectChanges = new Set(_toConsumableArray(this.objectChanges));
      this.objectChanges.clear();
      return objectChanges;
    }
  }, {
    key: "addMutation",
    value: function addMutation(mutation, objectChangePath) {
      var currentFlushId = this.master.currentFlushId;
      this.mutations.push(mutation);

      if (objectChangePath) {
        this.objectChanges.add(objectChangePath);
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.master.mutationCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var cb = _step.value;
          cb(mutation, new Set(objectChangePath ? [mutation.path, objectChangePath] : [mutation.path]), currentFlushId);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.mutationCallbacks[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var callback = _step2.value;
          callback(mutation, new Set(objectChangePath ? [mutation.path, objectChangePath] : [mutation.path]), currentFlushId);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "flush",
    value: function flush() {
      var isAsync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this.master.flush(this, isAsync);
    }
  }, {
    key: "onMutation",
    value: function onMutation(callback) {
      this.mutationCallbacks.push(callback);
    }
  }, {
    key: "canMutate",
    value: function canMutate() {
      return this.isTracking;
    }
  }, {
    key: "canTrack",
    value: function canTrack() {
      return false;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.isTracking = false;
      this.mutationCallbacks.length = 0;
      this.proxifier = this.master.proxifier;
      return this;
    }
  }]);

  return MutationTree;
}();